export type MaintenancePartItem = {
  enable: boolean;
  show_on_main: boolean;
  show_on_summary: boolean;
  force_display_text: string;
  title: string;
};
type MaintenancePartGroupItem = {
  maintenance_parts: {
    [key: string]: MaintenancePartItem;
  };
  title: string;
};
export enum MaintenancePartGroupsKey {
  General = 'general',
}

export enum MaintenanceCostKey {
  CostBeforeVat = 'cost_before_vat',
  Discount = 'discount_amount',
  DiscountCoupon = 'discount_coupon',
  TotalCostWithVat = 'total_cost_with_vat',
}

type MaintenancePartGroups = {
  [key: string]: MaintenancePartGroupItem;
};

export type RegularMaintenaceScheduleOnlyMonthMileage = {
  mileage: number;
  month: number;
};
export type RegularMaintenaceSchedule = {
  cost_before_vat: number;
  discount_amount: number;
  discount_coupon: string;
  maintenance_part_groups: MaintenancePartGroups;
  maintenance_privileges: string[];
  preventive_maintenance_parts?: string[];
  total_cost_with_vat: number;
  maintenance_description?: string;
  special_cost_description?: string;
} & RegularMaintenaceScheduleOnlyMonthMileage;

type ContentstackMaintenanceResponse = {
  title: string;
  class_one_marketing_grade: string;
  drive_system: string;
  engine_model: string;
  engine_size: string;
  european_emission_standard: string;
  marketing_model_year_begin_and_end: string;
  model_year_begin: number;
  series_marketing_model_name: string;
  transmission_system: string;
  vehicle_body_type: string;
  vehicle_name: string;
};

export type ContentstackLcvMaintenanceOptionResponse =
  ContentstackMaintenanceResponse & {
    regular_maintenance_schedules: RegularMaintenaceScheduleOnlyMonthMileage[];
  };

export type ContentstackLcvMaintenanceListResponse =
  ContentstackMaintenanceResponse & {
    model_year_end: number;
    remark: string;
    suggests: string[];
    regular_maintenance_schedules: RegularMaintenaceSchedule[];
  };

export type ContentstackCvMaintenanceOptionResponse =
  ContentstackMaintenanceResponse & {
    marketing_horse_power: number;
    sub_model_group: number;
    transmission_speed: number;
    regular_maintenance_schedules: RegularMaintenaceScheduleOnlyMonthMileage[];
  };

export type ContentstackCvMaintenanceListResponse =
  ContentstackMaintenanceResponse & {
    marketing_horse_power: number;
    sub_model_group: number;
    transmission_speed: number;
    model_year_end: number;
    remark: string;
    suggests: string[];
    regular_maintenance_schedules: RegularMaintenaceSchedule[];
  };

export type ContentstackAllVehicleTypeMaintenanceOptionResponse =
  ContentstackLcvMaintenanceOptionResponse &
    ContentstackCvMaintenanceOptionResponse;

export type ContentstackAllVehicleTypeMaintenanceListResponse =
  ContentstackLcvMaintenanceListResponse &
    ContentstackCvMaintenanceListResponse;

export type MaintenanceOptionGroupedItem = {
  key: string;
  label: string;
  children: ContentstackAllVehicleTypeMaintenanceOptionResponse[];
};
